module.exports = __webpack_public_path__ + "static/media/kanemite_15sc.c00259c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/climasense/acaro_manzano/curativa/kanemite_15sc.png
// module id = 1743
// module chunks = 3